export const GetStateByZipCode = async (zip) => {
  try {
    const response = await fetch(`https://api.zippopotam.us/us/${zip}`);
    if (!response.ok) {
      throw new Error("Invalid ZIP Code or not found");
    }
    const data = await response.json();
    if (data?.places?.length && data?.places[0]["state abbreviation"]) {
      return data.places[0]["state abbreviation"];
    } else {
      return null;
    }
  } catch (error) {
    console.error(error.message);
    return null;
  }
};
